import { render, staticRenderFns } from "./missive.vue?vue&type=template&id=754b7e34&scoped=true&"
import script from "./missive.vue?vue&type=script&lang=js&"
export * from "./missive.vue?vue&type=script&lang=js&"
import style0 from "./missive.vue?vue&type=style&index=0&id=754b7e34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b7e34",
  null
  
)

export default component.exports